import styled from "styled-components";
import { colors } from "../../../theme/colors";

export const StyledHeaderWrapper = styled.div`
  min-height: ${(props) => (props.isDefault ? "100px" : "100px")};
  width: 100%;
  background-color: ${(props) =>
    props.isDefault ? colors.primary : colors.white.main};
  padding: 0.5rem 0;
  position: relative;
  z-index: 1000;

  ${(props) =>
    props.isDefault &&
    `
    position: sticky;
    top: 0;
  `}
`;

export const MenuButton = styled.div`
  width: 28px;
  height: 22px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  span {
    width: 100%;
    height: 3px;
    background-color: ${colors.secondary};
    transition: all 0.3s ease;
    border-radius: 2px;
    transform-origin: center;
  }

  ${(props) =>
    props.isOpen &&
    `
    span:nth-child(1) {
      transform: rotate(45deg) translate(7px, 7px);
    }
    
    span:nth-child(2) {
      opacity: 0;
      transform: scale(0);
    }
    
    span:nth-child(3) {
      transform: rotate(-45deg) translate(7px, -7px);
    }
  `}

  &:hover span {
    opacity: 0.8;
  }
`;

export const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  z-index: 1001;
  overflow-y: auto;

  ${(props) =>
    props.isOpen
      ? `
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  `
      : `
    opacity: 0;
    visibility: hidden;
    transform: translateY(-20px);
  `}
  transition: all 0.3s ease;
`;

export const MenuContent = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.isOpen
      ? `
    opacity: 1;
    transform: scale(1);
  `
      : `
    opacity: 0;
    transform: scale(0.95);
    pointer-events: none;
  `}
  transition: all 0.3s ease;
`;

export const MenuHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-color: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2.5%;
  z-index: 1002;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    padding-left: 2rem;
  }
`;

export const MenuBody = styled.div`
  width: 95%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 120px;
  padding-bottom: 40px;
  flex: 1;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    padding-top: 120px;
    width: 90%;
    align-items: flex-start;
  }
`;

export const MenuSection = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    text-align: center;
    margin-bottom: 2rem;
  }
`;

export const AppStoreButton = styled.div`
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  img {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    transform: rotate(90deg);
  }
`;

export const AppStoreLinks = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: row;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: row;

  @media (max-width: 768px) {
    align-items: flex-start;
    padding-left: 1rem;
  }
`;

export const AdditionalLinks = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: row;

  @media (max-width: 768px) {
    align-items: flex-start;
    padding-left: 1rem;
  }
`;
